module.exports = __webpack_public_path__ + "88776bd8d5c50c88b21ea3401736fc23.svg";